// extracted by mini-css-extract-plugin
export default {"chart":"chart_chart__jOI7D","column":"chart_column__Beid9","value":"chart_value__QPL3n","tooltip":"chart_tooltip__in-rG"};